import { Redirect } from "react-router-dom";
import { RouteProvider } from "./Provider";
import { Spinner } from "views/mobile/components/common";
import { useLoginWithProvider } from "state/users/hooks";
import { useVersion } from "../../hooks/version";
import React, { useDispatch, useGlobal, useState, useEffect } from "reactn";
import type RouteComponentProps from "react-router";

const WelcomeProvider = ({ history, location, children }) => {
	const [user] = useGlobal("user");
	const version = useVersion();
	const [showLabel, setShowLabel] = useState(false);

	const referrer =
		location.state && location.state.from ? location.state.from : "/home";

	const [
		logIn,
		success,
		loadingGoogle,
		error,
		loadingFacebook,
		loadingMicrosoft,
	] = useLoginWithProvider();

	useEffect(() => {
		const timeout =
			loadingGoogle || loadingFacebook || loadingMicrosoft
				? setTimeout(
						() => setShowLabel(true),

						5000
				  )
				: null;

		return () => clearTimeout(timeout);
	}, [loadingGoogle, loadingFacebook, loadingMicrosoft]);

	if (user && user.token) return <Redirect to="/" />;

	if (success) return <Redirect to={referrer} />;

	return children({
		referrer,
		version,
		logIn,
		loadingGoogle,
		loadingFacebook,
		loadingMicrosoft,
		error,
		showLabel,
	});
};

export default RouteProvider(WelcomeProvider);
